export * from '@wix/table-reservations_app-extensions/dashboard';